import React from 'react';
import { pluralize } from '../util';

interface Props {
  numOfItems: number;
  hovered: boolean;
  username: string;
}
const UserDetails: React.FC<Props> = (props: Props) => {
  const today = new Date().toLocaleDateString();
  return (
    <>
      <div>
        <h3 className="heading">User name</h3>
        <p className="value">{props.username}</p>
      </div>
      <div>
        <h3 className="heading">Created on</h3>
        <p className="value">{today}</p>
      </div>
      <div>
        <h3 className="heading">Number of banks connected</h3>
        <p className="value">
          {props.hovered ? 'View ' : ''}{' '}
          {`${props.numOfItems} ${pluralize('bank', props.numOfItems)}`}
        </p>
      </div>
    </>
  );
};

UserDetails.displayName = 'UserDetails';

export default UserDetails;
